import { styled } from "@phntms/css-components";
import Image from "next/image"
import styles from "./styles.module.scss";

export const SocialLinksContainer = styled('div', {
  css: styles.socialLinksContainer,
  variants: {
    hideInMobile: {
      true: styles.hideMobile
    }
  }
  }
);


export const LinkIcon = styled(Image, {
  css: styles.linkIcon,
})
